export const LectureProgressRateTableConfig = [
  {
    title: "수강생 ID",
    dataIndex: "user.id"
  },
  {
    title: "email",
    dataIndex: "user.email",
    scopedSlots: { customRender: "email" }
  },
  {
    title: "수강생",
    dataIndex: "user.name"
  },
  {
    title: "이수율",
    scopedSlots: { customRender: "progress" }
  }
];
